import BannerAd from './BannerAd.js';

class BannerTakeover extends BannerAd {
    _styleAsTakeover() {
        this._container.classList.add('ad-takeover');
    }

    _toggleOn() {
        this._container.classList.add('in-screen');
        this._styledVisible = true;
    }

    _toggleOff() {
        this._container.classList.remove('in-screen');
        this._styledVisible = false;
    }

    toggleInScreenClass() {
        const lookAheadOffset = 300; // #px for triggering in-screen toggle
        const isInView = this.isInViewport(lookAheadOffset);
        const isVisible = this.isStyledVisible();

        if (!isVisible && isInView) {
            this._toggleOn();
        } else if (isVisible && !isInView) {
            this._toggleOff();
        }
    }

    _setToViewportHeight() {
        const vH = Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
        );

        document
            .querySelectorAll('.ad-takeover')
            .forEach(ele =>
                ele.style.setProperty('height', `${vH}px`, 'important')
            );
    }

    _listenToOrientationChange() {
        let orientationTimer;
        const UPDATE_TIMEOUT = 150;

        window.addEventListener('orientationchange', () => {
            // viewport height value is not updated immediately by the browser
            // need to delay resizing by 150-200ms
            clearInterval(orientationTimer);
            orientationTimer = setTimeout(() => {
                this._setToViewportHeight();
            }, UPDATE_TIMEOUT);
        });
    }

    _observeTakeoverAd(ad) {
        let scrollTimer;
        const SCROLL_TIMEOUT = 30;

        window.addEventListener('scroll', () => {
            clearInterval(scrollTimer);
            ad.toggleInScreenClass();
            scrollTimer = setTimeout(() => {}, SCROLL_TIMEOUT);
        });
    }

    render() {
        if (this._adObj != null) {
            this._styleAsTakeover();
            this._toggleOn();
            this._setToViewportHeight();
            this._listenToOrientationChange();
            this._observeTakeoverAd(this);
        }
    }
}

export default BannerTakeover;



// WEBPACK FOOTER //
// ./services/banner2/types/BannerAdTakeover.js